import type { ApiError } from "@circle-react/config/CustomErrors";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

export const useV4Rollback = () => {
  const { error } = useToast();

  return useMutation<unknown, ApiError>({
    mutationFn: () =>
      reactQueryPost(internalApi.settings.v4_ui_preference.rollback()),
    onSuccess: () => {
      window.location.href = "/";
    },
    onError: () => {
      error(t("failed_to_save_changes"));
    },
  });
};
